import React, { useState, useEffect } from "react";
import { query_string } from "./queries";

const debug = query_string("debug");

interface MyButtonProps {
    className?: string,

    disabled?: boolean,
    selected?: boolean,
    marked?: boolean,

    style?: Object,
    disabledStyle?: Object,
    hoverStyle?: Object,
    selectedStyle?: Object,
    markedStyle?: Object,

    children?: string | number | JSX.Element | JSX.Element[],
    onClick?: (evt: React.MouseEvent<HTMLButtonElement>) => void,
}

function MyButton(props: MyButtonProps) {
    const [disabled, setDisabled] = useState(props.disabled);
    const [className, setClassName] = useState(props.className);
    const [marked, setMarked] = useState(props.marked);
    const [selected, setSelected] = useState(props.selected);
    const [hover, setHover] = useState(false);
    const [style, setStyle] = useState(props.style);

    useEffect(() => {
        if (debug.indexOf("button") >= 0) console.log(`disabled=${disabled} hover=${hover} selected=${selected} marked=${marked}`);
        if (disabled) {
            setHover(false);
            setStyle(props.disabledStyle);
            return;
        }
        if (selected) {
            setStyle(props.selectedStyle);
            return;
        }
        if (hover) {
            setStyle(props.hoverStyle);
            return;
        }
        if (marked) {
            setStyle(props.markedStyle);
            return;
        }
        setStyle(props.style);
    }, [disabled, hover, selected, marked]);

    useEffect(() => {
        setDisabled(props.disabled);
    }, [props.disabled])

    useEffect(() => {
        setMarked(props.marked);
    }, [props.marked])

    useEffect(() => {
        setSelected(props.selected);
    }, [props.selected])

    useEffect(() => {
        setClassName(props.className);
    }, [props.className])

    const changeHover = (hs: boolean) => (evt: React.MouseEvent<HTMLButtonElement>) => {
        setHover(hs);
    }

    return <button onClick={props.onClick}
        onMouseEnter={changeHover(true)}
        onMouseLeave={changeHover(false)}
        className={className}
        disabled={disabled}
        style={style}>
        {props.children}
    </button>
}

export default MyButton;
